import React, { PropsWithChildren } from 'react';
import ConditionalRoute from '../../components/routes/ConditionalRoute';
import { dashboardViewRole, UserModel } from '../../api/authentication/authentication.types';
import Reports from '../reports/view/Reports';
import { RouteComponentProps } from 'react-router';
import { SupplierModel } from '../../api/admin/admin.types';
import { AppState } from '../../store/store.types';
import { connect } from 'react-redux';

interface DashboardEntryProps extends RouteComponentProps {
  user: UserModel;
  supplier: SupplierModel;
}

class Dashboard extends React.PureComponent<PropsWithChildren<DashboardEntryProps>> {
  render() {
    return (
      <>
        {this.props.children}
        <ConditionalRoute
          acceptedRoles={dashboardViewRole}
          exact
          path={`${this.props.match.path}`}
          render={(routeProps) => <Reports {...routeProps} url="https://dub01.online.tableau.com/t/rcdashboards/views/Dashboard/Reservations"/>}
        />
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  supplier: state.authentication.activeSupplier
});

const DashboardEntity = connect(mapStateToProps, null)(Dashboard);

export default DashboardEntity;